export default "<app-merch-collection [data]=\"galleryView\" [category]=\"'print'\"></app-merch-collection>\n"